export default __webpack_public_path__ + "0f4f224bb6e71bb0147577cfeaca504b.png";